module.exports = __webpack_public_path__ + "img/10.edd2eb51.jpg";